export default "__VITE_ASSET__uFjUhRva__"